import {TweenMax,Circ,TimelineMax} from 'gsap'
import SplitText from 'gsap/SplitText'

import React from 'react'

class AnimatedTextBlock extends React.Component {

  constructor(){

      super()

      this.state = {
        animationTriggred:false,
        animationOutTriggred:false
      }

      this.onScroll = this.onScroll.bind(this)
  }

  onScroll(){
    let thisPageY = this.refs.textBlock.getBoundingClientRect().top
    let triggerPoint = (window.innerHeight - 300)

    //console.log(triggerPoint +','+thisPageY);

    if( triggerPoint > thisPageY ){

        if(!this.state.animationTriggred){
          this.animateIn();
        }
        //window.removeEventListener('scroll',this.onScroll)
    }

    //console.log(this.refs.textBlock.getBoundingClientRect().top);

    if(this.refs.textBlock.getBoundingClientRect().top<150){
      let transparancy = this.refs.textBlock.getBoundingClientRect().top/150
      //console.log('alpha',transparancy);
      TweenMax.set(this.refs.textBlock,{alpha:transparancy});
    }

  }

  componentDidMount(){
     window.addEventListener('scroll',this.onScroll)
  }

  componentWillUnmount(){
      window.removeEventListener('scroll',this.onScroll)

  }


  animateIn(){

      console.log("Trigger Animation");

      let text_tl = new TimelineMax()

      /// get paragraphs

      let splits

      if(this.refs.textBlock.querySelectorAll('p')){
          splits = this.refs.textBlock.querySelectorAll('p');
      }else{
        splits = [this.refs.textBlock];
      }




      for(let i=0; i<splits.length; i++){

        let textSplit = new SplitText(splits[i], {type:"words,chars"})
        let chars = textSplit.chars; //an array of all the divs that wrap each character

        // Animate Title
        text_tl.set(splits[i],{alpha:1})
        text_tl.staggerFrom(chars, 0.6, {opacity:0, y:70, rotationX:140,transformOrigin:"0% 50% -35",  ease:Circ.easeOut}, 0.03);
        // delay tween
        text_tl.to(splits[i],.5,{alpha:1});
      }

      this.setState({animationTriggred:true})

  }

  animateOut(){

    console.log("Trigger Out Animation");

    TweenMax.to(this.refs.textBlock,.5,{alpha:0})
    this.setState({animationOutTriggred:true})
  }


  render () {

    console.log(this.state.animationTriggred);
    let status = this.state.animationTriggred? ' show' : ' hide' ;


      return (
        <div className={this.props.className+(' animated-text-block ')+(status)}>
            <div ref="textBlock" dangerouslySetInnerHTML={{__html:this.props.text}} />
        </div>
      )

  }
}

export default AnimatedTextBlock;


// WEBPACK FOOTER //
// ./src/modules/text/AnimatedTextBlock.js